var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"icon-loader"}),_c('v-skeleton-loader',{staticClass:"d-flex flex-column text-card-loader"},[_c('span',{staticClass:"v-skeleton-loader__bone main-text"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }